
<feedback-display-header [title]="'feedback-session-feedback-display_transcript-header' | translate">
	<div header-filters *ngIf="hasAnalytics$ | async">
			<mat-form-field goSelect>
				<mat-select
					[disabled]="shouldTease"
					[(ngModel)]="selectedTranscription"
					(selectionChange)="selectOption($event)"
					disableOptionCentering
					panelClass="offsetPanel">
					<mat-select-trigger>
						{{ getSelectedTranscription() }}
					</mat-select-trigger>
					<mat-option *ngFor="let option of transcriptSelectOptions" [value]="option">
						{{ transcriptSelectTranslations[option] | translate }}
					</mat-option>
				</mat-select>
				<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
			</mat-form-field>
			<badge *ngIf="shouldShowTranscriptAdvancedBadge()"
				   [badgeColor]="BadgeColors.SUCCESS"
				   [badgeLabel]="'common_advanced-plan' | translate">
			</badge>
			<span *ngIf="showBetaLabel()" class="beta-label" translate="common_beta"></span>
		</div>
		<div header-menu>
		<ng-container *ngIf="parsedMediaTranscript$ | async as transcript">
			<ng-container *ngIf="!shouldTease && isTranscriptCompleteWithContent(transcript)">
				<button
					type="button"
					id="transcript-action-menu-btn"
					class="icon-btn"
					[matMenuTriggerFor]="actionsMenu"
					class="btn btn-xs menu-btn"
					[attr.aria-label]="'transcript-viewer-menu_aria-label' | translate">
					<i class="ficon-app-dots-vertical"></i>
				</button>
				<mat-menu #actionsMenu class="action-menu">
					<button
						mat-menu-item
						(click)="downloadTranscript()"
						id="download-transcript-menu-btn">
						<span translate="transcript-viewer-menu_download-transcript"></span>
					</button>
					<button
						mat-menu-item
						*ngIf="canEditSpeakers()"
						(click)="editSpeakers($event, ButtonSource.Menu)"
						id="edit-speakers-menu-btn">
						<span translate="transcript-viewer-menu_edit-speakers"></span>
					</button>
				</mat-menu>
			</ng-container>
		</ng-container>
	</div>
</feedback-display-header>

<!-- Fetching Transcript -->
<div class="loading-view" *ngIf="isLoading$ | async; else notLoaded">
	<i class="ficon-spinner ficon-spin"></i>
	<span translate="common_loading"></span>
</div>

<!-- Error Fetching Transcript -->
<ng-template #notLoaded>
	<ng-container *ngIf="(requestErrorOccurred$ | async) && !shouldTease">
		<ng-container *ngIf="!media.isYoutube()">
			<ngx-zero-state class="launch-ai-zero-state" *ngIf="shouldShowLaunchAIZeroState()">
				<div zero-state-title translate="transcript-viewer-zero-state_launch-ai"></div>
				<div zero-state-subtext>
					<div translate="transcript-viewer-zero-state_launch-ai-subtext"></div>
					<div>
						<button (click)="runAI()" class="run-ai-button primary-btn" [disabled]="isRunningAI$ | async">
							{{'transcript-viewer-zero-state_launch-ai-run-ai' | translate}}
						</button>
					</div>
				</div>
				<div zero-state-graphic-bottom>
					<img class="zero-state-image"
						 src="https://staticassets.goreact.com/Rocket.svg"
						 alt="{{'transcript-viewer-zero-state_launch-ai' | translate}}">
				</div>
			</ngx-zero-state>

			<ngx-zero-state class="loading-failed-zero-state" *ngIf="!shouldShowLaunchAIZeroState()">
				<div zero-state-title translate="transcript-viewer-zero-state_loading-failed"></div>
				<div zero-state-subtext translate="transcript-viewer-zero-state_loading-failed-subtext"></div>
				<div zero-state-graphic-bottom>
					<img class="loading-failed-zero-state-image zero-state-image"
						 src="https://staticassets.goreact.com/floating-astronaut.svg"
						 alt="{{'transcript-viewer-zero-state_loading-failed-image-alt' | translate}}">
				</div>
			</ngx-zero-state>
		</ng-container>

		<ngx-zero-state class="loading-failed-zero-state" *ngIf="media.isYoutube()">
			<div zero-state-title translate="transcript-viewer-zero-state_youtube"></div>
			<div zero-state-subtext translate="transcript-viewer-zero-state_youtube-subtext"></div>
			<div zero-state-graphic-bottom>
				<img class="loading-failed-zero-state-image zero-state-image"
					 src="https://staticassets.goreact.com/floating-astronaut.svg"
					 alt="{{'transcript-viewer-zero-state_loading-failed-image-alt' | translate}}">
			</div>
		</ngx-zero-state>
	</ng-container>
</ng-template>

<!-- Transcript Successfully Fetched -->
<section class="transcript-container" *ngIf="parsedMediaTranscript$ | async as transcript">

	<!-- Transcript Processing -->
	<div class="loading-view"
		*ngIf="transcript.status === TranscriptStatus.PROCESSING || transcript.status === TranscriptStatus.QUEUED">
		<i class="ficon-spinner ficon-spin"></i>
		<span translate="transcript-viewer-zero-state_transcript-processing-subtext"></span>
	</div>

	<!-- Transcript Failed -->
	<ngx-zero-state *ngIf="transcript.status === TranscriptStatus.ERROR">
		<div zero-state-title translate="transcript-viewer-zero-state_loading-failed"></div>
		<div zero-state-subtext translate="transcript-viewer-zero-state_transcript-failed-subtext"></div>
		<div zero-state-graphic-bottom>
			<img class="zero-state-image"
				 src="https://staticassets.goreact.com/floating-astronaut.svg"
				 alt="{{'transcript-viewer-zero-state_loading-failed-image-alt' | translate}}">
		</div>
	</ngx-zero-state>

	<ngx-zero-state class="loading-failed-zero-state" *ngIf="transcript.status === TranscriptStatus.COMPLETED && transcript.sentencesAndChapters.length === 0">
		<div zero-state-title translate="transcript-viewer-zero-state_audio-lost"></div>
		<div zero-state-subtext translate="transcript-viewer-zero-state_audio-lost-subtext"></div>
		<div zero-state-graphic-bottom>
			<img class="loading-failed-zero-state-image zero-state-image"
				 src="https://staticassets.goreact.com/floating-astronaut.svg"
				 alt="{{'transcript-viewer-zero-state_loading-failed-image-alt' | translate}}">
		</div>
	</ngx-zero-state>

	<!-- Transcript Complete -->
	<ng-container *ngIf="isTranscriptCompleteWithContent(transcript)">
		<section class="tease-container" *teaseWall="teaseWallConfig;">
			<transcript-search
				[searchResults]="searchResults$ | async"
				[currentSearchIndex]="currentSearchIndex"
				(currentSearchIndexChange)="onSearchIndexChange($event)"
				(searchTextChange)="onSearchTextChange($event)"
			>
			</transcript-search>
			<div
				*ngIf="stickyChapter$ | async as stickyChapter"
				class="sticky-chapter-title"
				[style.boxShadow]="(scrollStrategy.scrolledIndexChange | async) > 0 ? '0 3px 2px -2px rgba(0, 0, 0, 0.1)' : 'none'"
			>
				<div class="chapter-title" role="heading" aria-level="6" tabindex="0">{{ stickyChapter.title }}</div>
			</div>
			<cdk-virtual-scroll-viewport class="virtual-viewport" [style.overflow-y]="shouldTease ? 'hidden':'auto'">
				<ul role="list" class="sentence-list">
					<li
						role="listitem"
						*cdkVirtualFor="let sentenceOrChapter of transcript.sentencesAndChapters; templateCacheSize: 25;"
						[attr.data-sentence-id]="isChapter(sentenceOrChapter) ? 'chapter-' + sentenceOrChapter.id : 'sentence-' + sentenceOrChapter.id"
						class="transcript-item"
						[ngClass]="sentenceStyles.get(sentenceOrChapter.id)">
						<ng-container *ngIf="isChapter(sentenceOrChapter)">
							<div *ngIf="sentenceOrChapter.id !== (stickyChapter$ | async)?.id; else chapterPlaceholder" class="chapter-title" role="heading" aria-level="6" tabindex="0">{{ sentenceOrChapter.title }}</div>
							<ng-template #chapterPlaceholder>
								<div
									class="chapter-title-placeholder"
									[style.display]="sentenceOrChapter.id === transcript.sentencesAndChapters[0]?.id ? 'none' : null"
								></div>
							</ng-template>
						</ng-container>
						<ng-container *ngIf="!isChapter(sentenceOrChapter)">
							<button [tabindex]="shouldTease ? -1: 0" class="sentence-button" data-cy="transcription-sentence" (click)="onSentenceClick(sentenceOrChapter)"
									[attr.aria-label]="('transcript-viewer_jump-to' | translate) + (sentenceOrChapter.start | formatTime)
								+ ', ' + ('transcript-viewer_speaker' | translate : { speaker: sentenceOrChapter.speaker})
								+ ', ' + sentenceOrChapter.parsedText">
							<span class="time-container">
								<span class="time-text">
									{{ sentenceOrChapter.start | formatTime }}
								</span>
							</span>
							<span class="sentence-details">
								<span class="sentence-speaker" [hidden]="(isMultiSpeaker$ | async) === false">
									<ng-container *ngIf="sentenceOrChapter.speaker.length === 1">
										{{ 'transcript-viewer_speaker' | translate: { speaker: sentenceOrChapter.speaker } }}
									</ng-container>
									<ng-container *ngIf="sentenceOrChapter.speaker.length > 1">
										{{ sentenceOrChapter.speaker }}
									</ng-container>
									<button
										*ngIf="canEditSpeakers$ | async"
										type="button"
										class="edit-speakers-button icon-btn"
										(click)="editSpeakers($event)"
										[attr.aria-label]="'edit-transcription-speakers_title' | translate">
										<i class="ficon-app-edit"></i>
									</button>
								</span>
								<span class="sentence-text">
									<ng-container *ngFor="let word of sentenceOrChapter.separateWords; let i = index; let last = last">
										<span [ngClass]="getWordStyle(sentenceOrChapter.id, i)">
											{{ word }}
											<ng-container *ngIf="!last">&#160;</ng-container>
										</span>
									</ng-container>
								</span>
							</span>
							</button>

							<div class="btn-bar transcript-item-toolbar visible-when-active pull-right" [style.margin-top]="sentenceOrChapter.id === firstSentenceId ? '2px' : null">
								<button
									class="btn btn-xs insert-quote-btn"
									[attr.aria-label]="'transcript-viewer-list-item_insert-quote' | translate"
									[matTooltip]="'transcript-viewer-list-item_insert-quote' | translate"
									matTooltipPosition="below"
									(click)="insertQuote(sentenceOrChapter)">
									<i class="ficon-quote"></i>
								</button>
							</div>
						</ng-container>
					</li>
				</ul>
			</cdk-virtual-scroll-viewport>

			<jump-to-current-time-button
				[scrollDirection]="scrollDirection$ | async"
				[hasTags]="tagsList && tagsList.length > 0"
				(jumpToCurrentTime)="jumpToCurrentTime()">
			</jump-to-current-time-button>

		</section>
	</ng-container>
</section>


